/**   
 * 统一权限接口统一管理
 */
import { axiosPostJson } from './http';

const prexfix = global.$config.api.apiUrl;
// const prexfix = 'https://biaozhunhua.zjht100.com/tsscjk'
// const prexfix = 'http://biaozhunhua.zjht100.com'

// 上传文件
export const uploadFile = (data) => {
  let form = new FormData();
  form.append("file", data);

  return axiosPostJson(prexfix + `/common-api/common/uploadFiles`, form)
};

// 删除文件
export const deleteFile = (data) => {
  let form = new FormData();
  form.append("file_id", data);

  return axiosPostJson(prexfix + `/common-api/common/deleteFile`, form)
};



let fileApi = {
  uploadFile,
  deleteFile,
};

export default fileApi;